import NextImg from "next/image";
import { useEffect, useRef, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BsPlayCircle } from "react-icons/bs";
import styled from "styled-components";
import Container from "../../shared/Container";

const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
  pointer-events: none;
  visibility: hidden;
  opacity: 0;
  transition: all 0.6s ease-in;

  &.active {
    visibility: visible;
    pointer-events: all;
    opacity: 1;
    transition: all 0.5s ease-in-out;
  }

  video {
    height: 100%;
    width: 100%;
  }
`;

// const Shadow = styled.div`
//   z-index: 99999;
//   pointer-events: none;
//   visibility: hidden;
//   opacity: 0;
//   transition: all 0.4s ease-in;

//   &.active {
//     visibility: visible;
//     pointer-events: all;
//     opacity: 1;
//     transition: all 0.4s ease-in;
//   }
// `;

const AboutEt = () => {
  const [showVideo, setShowVideo] = useState(false);
  const [videoUrl, setVideoUrl] = useState("/imagess/ET Video.mp4");
  const videoRef = useRef();

  useEffect(() => {
    if (!videoRef.current) return;

    if (showVideo) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  }, [showVideo]);

  return (
    <>
      <div
        className={`bg-opaciy-50 bg-black fixed top-0 left-0 h-screen w-screen z-[9999] transition-all ${
          showVideo ? "visible pointer-events-auto opacity-100 bg-opacity-80" : "pointer-events-none invisible opacity-0"
        }`}>
        <div className="absolute top-0 right-0 pt-4 mx-10">
          <AiOutlineClose onClick={() => setShowVideo(false)} className="bg-red-500 h-8 w-8 p-1 text-white cursor-pointer  rounded-full z-50" />
        </div>
      </div>

      <Modal className={`h-[500px] w-11/12 md:w-[60vw]  ${showVideo ? "active" : ""}`}>
        <video ref={videoRef} src={videoUrl} className={`object-cover ${showVideo ? "block" : "hidden"}`} controls autoPlay loop></video>
      </Modal>

      <div className="bg-[#EBF3FD] md:rounded-tl-[8rem] md:rounded-br-[8rem] relative mt-10">
        {/* <svg className="absolute top-0 left-0" width="201" height="201" viewBox="0 0 201 201" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M201 0H0V201H1V200C1 89.543 90.5431 0 201 0Z" fill="#F5CC24" />
        </svg> */}

        <Container className="py-12 md:py-24 relative">
          <div className="md:w-[65%]">
            <h2 className="text-[2rem] md:text-5xl leading-[1.3] font-medium">
              Simply Consistent. <br /> Surprisingly Creative.
            </h2>
            <p className="my-8 text-gray-600 text-lg leading-[2]">
              The new employee twins from HAP come with all that you seek in your team - resilience, smartness & learnability. And with Generative AI, you have more
              reasons than ever to choose Employee Twin-Legend. Supercharged with over 200 skills and anchored on MS Teams, versatility never came this easy. What’s more
              - over 10 new skills added every month!
            </p>

            {/* <p>
                Hire your first Employee Twin for as low as 99/mo.* <br />{" "}
                <Link href={"/"} className="text-main font-medium mr-1">
                  New
                </Link>
                Employee Twin Legend from 222/mo.*
              </p> */}

            <div className="text-main mt-6 font-medium md:flex items-center gap-x-6 text-xl md:text-sm">
              <button
                className="flex items-center gap-x-2 duration-500  hover:text-blue-400"
                onClick={() => {
                  setVideoUrl("/imagess/ET Video.mp4");
                  setShowVideo(true);
                }}>
                <span>Watch the film</span>
                <BsPlayCircle className="mt-1" />
              </button>

              <button
                className="flex items-center gap-x-2 duration-500 md:mt-0  hover:text-blue-400"
                onClick={() => {
                  setVideoUrl("/imagess/AARAMBH VIDE.mp4");
                  setShowVideo(true);
                }}>
                <span>Watch ET in Action</span>
                <BsPlayCircle className="mt-1" />
              </button>
            </div>
          </div>
          <figure class="md:absolute bottom-14 right-14">
          <NextImg className="md:absolute bottom-14 right-14" src={"/imagess/icon.png"} height={250} width={250} />
          </figure>   
     </Container>
      </div>
    </>
  );
};

export default AboutEt;
